
















  import Vue from 'vue';

  export default Vue.extend({
props: {
  correctNum: Number,
  wrongNum: Number,
  visible: Boolean
}
  });
